import indicatorCircuitDmp from './circuit-dmp/indicator-circuit-dmp.locales'
import indicatorCircuitInheritance from './circuit-inheritance/indicator-circuit-inheritance.locales'
import indicatorCircuitProtection from './circuit-protection/indicator-circuit-protection.locales'
import indicatorCircuitRetirement from './circuit-retirement/indicator-circuit-retirement.locales'
import indicatorCircuitTaxation from './circuit-taxation/indicator-circuit-taxation.locales'
import indicatorCircuitInvestorProfile from './investor-profile/indicator-circuit-investor-profile.locales'

export default {
  indicatorCircuitDmp,
  indicatorCircuitInheritance,
  indicatorCircuitProtection,
  indicatorCircuitRetirement,
  indicatorCircuitTaxation,
  indicatorCircuitInvestorProfile,
}
